export default "__VITE_ASSET__BrzPdVVu__"